module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "copy2"
  }, [_c('a', {
    attrs: {
      "id": "page_iv"
    }
  }), _vm._v("Copyright © 2009 by Ralph L. Bayrer")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("New Academia Publishing, 2010")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("All rights reserved. No part of this book may be reproduced or transmitted in any form or by any means, electronic or mechanical, including photocopying, recording, or by any information storage and retrieval system.")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("Library of Congress Control Number: 2009935178")]), _vm._v(" "), _c('p', {
    staticClass: "copy0"
  }, [_vm._v("ISBN 978-0-9823867-4-3 paperback (alk. paper)")]), _vm._v(" "), _c('table', [_c('tbody', [_c('tr', [_c('td', [_c('p', {
    staticClass: "copyz"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/f00iv-1.jpg"
    }
  })])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "copy0"
  }, [_vm._v("New Academia Publishing, LLC")]), _vm._v(" "), _c('p', {
    staticClass: "copy0"
  }, [_vm._v("P.O. Box 27420")]), _vm._v(" "), _c('p', {
    staticClass: "copy0"
  }, [_vm._v("Washington, DC 20038-7420")]), _vm._v(" "), _c('p', {
    staticClass: "copy0"
  }, [_c('span', {
    staticClass: "weblink"
  }, [_c('a', {
    attrs: {
      "href": "http://www.newacademia.com",
      "target": "_blank"
    }
  }, [_c('span', {
    staticClass: "underline"
  }, [_vm._v("www.newacademia.com")])])]), _vm._v(" - "), _c('span', {
    staticClass: "weblink"
  }, [_c('a', {
    attrs: {
      "href": "mailto:info@newacademia.com"
    }
  }, [_c('span', {
    staticClass: "underline"
  }, [_vm._v("info@newacademia.com")])])])])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-048fda84","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/04_copyright.vue
// module id = 69
// module chunks = 0